/* AULBERY — FAQ (as-faq.js)
   Moved 1:1 from the inline <script> in sections/as-faq.liquid. Rows are
   native <details>/<summary>; this only adds the optional close-others
   behaviour and the height animation. Options come from data attributes on
   the [data-as-faq] root; pending timeouts are cleared on section unload. */
(function () {
  function initFaq(root) {
    if (!root || root.dataset.asFaqInit === '1') return;
    root.dataset.asFaqInit = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-asq-item]'));
    var single = root.dataset.oneOpen === 'true';
    var speed = parseInt(root.dataset.animMs, 10);
    if (isNaN(speed)) speed = 240;

    // every pending timeout, so unload can clear them
    var timers = [];
    function later(fn, ms) {
      var t = setTimeout(function () {
        var at = timers.indexOf(t);
        if (at > -1) timers.splice(at, 1);
        fn();
      }, ms);
      timers.push(t);
    }

    function slideOpen(d) {
      var panel = d.querySelector('.asq-a');
      if (!panel) return;
      d.open = true;
      var h = panel.scrollHeight;
      panel.style.height = '0px';
      panel.style.transition = 'height ' + speed + 'ms ease';
      requestAnimationFrame(function () {
        panel.style.height = h + 'px';
      });
      later(function () {
        panel.style.height = '';
        panel.style.transition = '';
      }, speed);
    }

    function slideClose(d) {
      var panel = d.querySelector('.asq-a');
      if (!panel) {
        d.open = false;
        return;
      }
      var h = panel.scrollHeight;
      panel.style.height = h + 'px';
      panel.style.transition = 'height ' + speed + 'ms ease';
      requestAnimationFrame(function () {
        panel.style.height = '0px';
      });
      later(function () {
        d.open = false;
        panel.style.height = '';
        panel.style.transition = '';
      }, speed);
    }

    items.forEach(function (d) {
      var summary = d.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) {
          slideClose(d);
          return;
        }
        if (single) {
          items.forEach(function (other) {
            if (other !== d && other.open) slideClose(other);
          });
        }
        slideOpen(d);
      });
    });

    root.asFaqCleanup = function () {
      timers.forEach(function (t) { clearTimeout(t); });
      timers = [];
    };
  }

  function scopeOf(e) {
    return e && e.target && e.target.querySelectorAll ? e.target : document;
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-as-faq]'), initFaq);
  }

  function unloadAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-as-faq]'), function (root) {
      if (typeof root.asFaqCleanup === 'function') root.asFaqCleanup();
      root.dataset.asFaqInit = '';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  // the editor re-runs this file when it re-renders a section; bind the
  // document listeners once
  if (!window.asFaqBound) {
    window.asFaqBound = true;
    document.addEventListener('shopify:section:load', function (e) { initAll(scopeOf(e)); });
    document.addEventListener('shopify:section:unload', function (e) { unloadAll(scopeOf(e)); });
  }
})();

